module.exports = __webpack_public_path__ + "img/guidedogswa.0efb556.png";